<template>
  <v-card max-width="600">
    <v-toolbar
      color="primary"
      dark
    >
      <v-toolbar-title>
        {{ title }}
      </v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <div class="subtitle-2 pb-3 font-weight-bold">Outfox AI is the easiest way to fundraise and get your message out to your supporters!</div>
      <div class="body-2">Set up your agency:</div>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex md6>
            <v-text-field
              v-model="name"
              :rules="rules"
              label="Agency Name"
            ></v-text-field>
          </v-flex>
          <!-- <v-flex md6>
            <v-text-field
              v-model="type"
              disabled
              :rules="rules"
              label="Agency Type"
            ></v-text-field>
          </v-flex> -->
          <v-flex md6>
            <v-text-field
              v-model="address"
              :rules="rules"
              label="Agency Address"
            ></v-text-field>
          </v-flex>
          <v-flex md6>
            <v-text-field
              v-model="city"
              :rules="rules"
              label="Agency City"
            ></v-text-field>
          </v-flex>
          <v-flex md6>
            <v-select
              v-model="state"
              :items="states"
              item-text="name"
              item-value="name"
              :rules="rules"
              label="Agency State"
            ></v-select>
          </v-flex>
          <v-flex md6>
            <v-text-field
              v-model="country"
              :rules="rules"
              label="Agency Country"
            ></v-text-field>
          </v-flex>
          <v-flex md6>
            <v-text-field
              v-model="zip"
              :rules="zipValidation"
              label="Agency ZIP"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        :disabled="!valid"
        @click.native="next"
      >
        Next
      </v-btn>
  </v-card-actions>
  </v-card>
</template>
<script>
import states from '../../../static/states'
export default {
  name: 'TheWelcomeAgencyForm',
  data () {
    return {
      valid: true,
      name: '',
      type: 'agency',
      address: '',
      city: 'New York',
      state: 'New York',
      states: [],
      country: 'USA',
      zip: '',
      rules: [(v) => !!v || 'This field is required'],
      zipValidation: [(v) => {
        const regex = /(^\d{5}$)|(^\d{5}-\d{4}$)/
        return regex.test(v) || 'Shoud be a 5-digit number'
      }]
    }
  },
  props: {
    title: {
      type: String,
      default: 'Welcome to Outfox AI'
    }
  },
  created () {
    this.states = states
  },
  methods: {
    next () {
      if (this.$refs.form.validate()) {
        const agency = {
          name: this.name,
          type: this.type,
          address: this.address,
          city: this.city,
          state: this.state,
          country: this.country,
          zip: this.zip,
          advertisers: []
        }
        new Promise(resolve => {
          resolve(this.$store.dispatch('createAgency', agency))
        })
          .then(res => {
            this.$emit('setAgency', res)
          })
      }
    }
  }
}
</script>
